import { LinkInfo } from '@/utils/fetchers/attachment'
import type { ContentType, Picture, UrlsInText } from './common'
import type { StoryStatus } from './story'
import type { Topic } from './topic'
import type { User } from './user'

export enum PostStatus {
	NORMAL = 'NORMAL',
	DELETED = 'DELETED',
}

export enum PostAction {
	USER_FOLLOW = 'USER_FOLLOW',
	USER_ENDOW = 'USER_ENDOW',
}

export interface Poi {
	poiId: string
	name: string
	location: number[]
	countryname: string
	pname: string
	cityname: string
	formattedAddress: string
}

export interface ReadTrackInfo {
	loadedAt: number
	feedType: FeedType
	storyStatus?: StoryStatus
}

export enum FeedType {
	FOLLOWING_UPDATES = 'FOLLOWING_UPDATES',
}

export type PostType = ContentType.POST | ContentType.REPOST | ContentType.PERSONAL_UPDATE

export interface StatsCount {
	topicSubscribed: number
	topicCreated: number
	followedCount: number
	followingCount: number
	highlightedPersonalUpdates: number
	liked: number
	respectedCount: number
}

export interface Rollouts {
	wmpShare: WmpShare
}

export interface WmpShare {
	id: string
	path: string
}

export interface EndowInfo {
	productId: string
	price: number
	name: string
	picInfo: Picture
}

export interface EndowTarget {
	id: string
	type: PostType
	content: string
	link: string
	user: User
}

export interface Post {
	id: string
	type: PostType
	actionTime?: string
	createdAt: string
	updateIds?: string[]
	action?: PostAction
	usernames?: string[]
	targetUsernames?: string[]
	users?: User[]
	targetUsers?: User[]
	targetUser?: User
	readTrackInfo?: ReadTrackInfo
	content: string
	rawContent?: string
	urlsInText: UrlsInText[]
	status?: PostStatus
	user?: User
	target?: Post
	targetType?: PostType
	rootType?: PostType
	topEndowers?: User[]
	hasMoreEndower?: boolean
	endowInfo?: EndowInfo
	endowTarget?: EndowTarget
	commentCount?: number
	repostCount?: number
	likeCount?: number
	shareCount?: number
	pictures?: Picture[]
	liked?: boolean
	deleted?: boolean
	collected?: boolean
	enablePictureComments?: boolean
	repostable?: boolean
	isCommentForbidden?: boolean
	topic?: Topic
	collectTime?: null
	isFeatured?: boolean
	isPrivate?: boolean
	isSuppressed?: boolean
	rollouts?: Rollouts
	likeIcon?: string
	syncCommentId?: string
	replyToComment?: Comment
	editableStatus: 'DISABLED' | 'ENABLED'
	editedAt?: string
	recordId?: string
	linkInfo?: LinkInfo
	poi?: Poi
	pinned?: {
		personalUpdate?: boolean
	}
	privatizableStatus?: 'ENABLE_HIDE' | 'ENABLE_RECOVER'
	video?: {
		duration: number
		source: string[]
		thumbnailUrl: string
		type: 'VIDEO'
	}
}
